import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAngular,
  faCss3Alt,
  faGitAlt,
  faGithub,
  faHtml5,
  faJenkins,
  faJira,
  faJs,
  faLinkedin,
  faNodeJs,
  faNpm,
  faPython,
  faReact,
  faSass,
  faUbuntu,
  faUnity,
  faVuejs,
  faYarn,
} from "@fortawesome/free-brands-svg-icons";

import {
  faBriefcase,
  faChevronUp,
  faCode,
  faCube,
  faDatabase,
  faEnvelope,
  faGraduationCap,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngular,
  faBriefcase,
  faChevronUp,
  faCode,
  faCube,
  faCss3Alt,
  faDatabase,
  faEnvelope,
  faGitAlt,
  faGithub,
  faGraduationCap,
  faHtml5,
  faJenkins,
  faJira,
  faJs,
  faLinkedin,
  faNodeJs,
  faNpm,
  faPython,
  faReact,
  faSass,
  faUbuntu,
  faUser,
  faUnity,
  faVuejs,
  faYarn
);
